<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="698px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="storageForm"
      label-position="top"
      :model="storage"
      :rules="rules"
      v-loading="loading"
    >
      <el-switch
        v-model="storage.is_active"
        active-text="Aktív"
        inactive-text="Inaktív"
        style="margin-bottom: 20px;"
      />
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Név"
            prop="name"
          >
            <el-input
              v-model="storage.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Típus"
            prop="type"
          >
            <el-select
              v-model="storage.type"
              style="width: 100%;"
            >
              <el-option
                value="own"
                label="Központi raktár"
              />
              <el-option
                value="representative"
                label="Képviselői raktár"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ILN">
            <el-input
              v-model="storage.iln"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="storage.type === 'representative'">
        <el-col :span="12">
          <el-form-item
            label="Képviselő"
            prop="user_id"
          >
            <el-select
              v-model="storage.user_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :value="user.id"
                :label="`${user.last_name} ${user.first_name}`"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Helyettes képviselő"
            prop="deputy_user_id"
          >
            <el-select
              v-model="storage.deputy_user_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :value="user.id"
                :label="`${user.last_name} ${user.first_name}`"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Irányítószám"
            prop="address.postal_code"
          >
            <el-input
              v-model="storage.address.postal_code"
              @change="onZipChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-loading="addressLoading"
            label="Város"
            prop="address.city"
          >
            <el-input
              v-model="storage.address.city"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            v-loading="addressLoading"
            label="Ország"
            prop="address.country_id"
          >
            <el-select
              v-model="storage.address.country_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="country in countries"
                :key="country.id"
                :value="country.id"
                :label="country.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-loading="addressLoading"
            label="Megye"
            prop="address.county_id"
          >
            <el-select
              v-model="storage.address.county_id"
              style="width: 100%;"
              filterable
              clearable
            >
              <el-option
                v-for="county in counties"
                :key="county.id"
                :value="county.id"
                :label="county.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Cím"
            prop="address.address"
          >
            <el-input
              v-model="storage.address.address"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-checkbox v-model="storage.is_listed_on_mobile">
        Mobil app-ban listázva
      </el-checkbox>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'storageId'],
  data() {
    return {
      loading: false,
      addressLoading: false,
      buttonLoading: false,
      storage: {
        is_active: true,
        is_listed_on_mobile: false,
        type: 'own',
        iln: null,
        address: {
          country: {},
          county: {},
        },
      },
      filterMethod(query, item) {
        return item.label.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .indexOf(query.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')) > -1;
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['user/users'];
    },
    countries() {
      return this.$store.getters['country/countries'];
    },
    counties() {
      return this.$store.getters['county/counties'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új raktár';
      } else if (this.type === 'update') {
        return 'Raktár módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch('country/fetchAll'),
      this.$store.dispatch('county/fetchAll'),
      this.$store.dispatch('user/fetchAll'),
    ]);
    if (this.storageId) {
      this.storage = await this.$store.dispatch('storage/fetch', this.storageId);
      if (!this.storage.address) {
        this.storage.address = {
          country: {},
          county: {},
        };
      }
    }
    this.loading = false;
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/data/storages');
        })
        .catch(() => {
        });
    },
    async onZipChange() {
      this.addressLoading = true;
      const data = await axios.get('/api/city/' + this.storage.address.postal_code);
      if (data) {
        this.storage = Object.assign({}, this.storage, {
          address: {
            ...this.storage.address,
            city: data.city,
            county_id: data.county_id,
            country_id: data.country_id,
          }
        });
      } else {
        this.storage = Object.assign({}, this.storage, {
          address: {
            ...this.storage.address,
            city: null,
            county_id: null,
          }
        });
      }
      this.addressLoading = false;
    },
    async store() {
      this.$refs['storageForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('storage/create', this.storage);
            } else if (this.type === 'update') {
              await this.$store.dispatch('storage/update', this.storage);
            }
            this.$store.dispatch('storage/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/data/storages');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
};
</script>

<style lang="scss">
  .customer-transfer {
    .el-transfer-panel {
      width: 280px;
      .el-checkbox.el-transfer-panel__item {
        display: block;
      }
    }
  }
</style>
